<div class="container portal-home pt-4">
  <div class="row g-4">
    <div class="col-12 col-lg-3">
      <div class="card sidebar-card">
        <div class="card-header">Filtrar Por</div>
        <div class="card-body p-0">
          @if (loadingFilters()) { <p class="m-3 text-body-secondary">Cargando filtros...</p> }
          @for (filter of filters(); track filter.key) {
            <section class="filter-section p-3">
              <h5 class="filter-title" [class.mb-0]="filter.options.length === 0">{{ filter.title }}</h5>
              @for (option of filter.options; track option.id) {
                @if (option.count > 0) {
                  <div class="form-check filter-option mb-2">
                    <input class="form-check-input" type="checkbox" [id]="filter.key + '-' + option.id" [checked]="option.selected" (change)="toggleOption(filter.key, option.id, $any($event.target).checked)" />
                    <label class="form-check-label" [for]="filter.key + '-' + option.id">
                      <span class="filter-option-label">{{ option.label }}</span>
                      <span class="badge rounded-pill text-bg-secondary filter-option-count">{{ option.count }}</span>
                      @if (option.image) {
                        <img class="filter-option-image" [src]="productImage(option.image)" alt="" />
                      } @else {
                        <span class="filter-option-placeholder" aria-hidden="true"><i class="bi bi-image"></i></span>
                      }
                    </label>
                  </div>
                }
              }
            </section>
          }
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-9 d-flex product-column">
      <section class="card products-card w-100">
        <div class="card-header d-flex flex-wrap justify-content-between align-items-center gap-2">
          <span>Productos</span>
          <div class="d-flex flex-wrap align-items-center justify-content-end gap-2">
            <small class="text-body-secondary">{{ filteredProducts().length }} registrados</small>
            <label class="visually-hidden" for="product-sort">Ordenar productos</label>
            <select id="product-sort" class="form-select form-select-sm product-sort" [value]="sort()" (change)="setSort($any($event.target).value)">
              <option value="release-desc">Lanzamiento: reciente a antiguo</option>
              <option value="release-asc">Lanzamiento: antiguo a reciente</option>
              <option value="processor">Procesador: A a Z</option>
              <option value="graphic-card">Tarjeta gráfica: A a Z</option>
              <option value="operating-system">Sistema operativo: A a Z</option>
              <option value="price-desc">Precio: mayor a menor</option>
              <option value="price-asc">Precio: menor a mayor</option>
            </select>
          </div>
        </div>
        <div class="card-body product-scroll-body">
          @if (loadingProducts()) {
            <p class="text-body-secondary mb-0">Cargando productos...</p>
          } @else {
            @for (product of visibleProducts(); track product.id) {
              <article class="card product-card mb-3" [class.border-danger]="hasDiscount(product)" [class.border-2]="hasDiscount(product)">
                <div class="card-body">
                  <div class="product-card-heading d-flex align-items-center justify-content-between gap-3 mb-3">
                    <h2 class="h5 product-title mb-0">{{ product.name }}</h2>
                    <div class="product-rating flex-shrink-0 text-end" [attr.aria-label]="productRating(product.id).averageRating + ' de 5 estrellas, ' + productRating(product.id).opinionCount + ' opiniones'">
                      <span class="fw-semibold me-1">{{ formatAverageRating(productRating(product.id).averageRating) }}</span>
                      <span class="comment-rating me-1">@for (star of ratingStars; track star) { <i class="bi" [class.bi-star-fill]="star <= productRating(product.id).averageRating" [class.bi-star]="star > productRating(product.id).averageRating"></i> }</span>
                      <small class="text-body-secondary">({{ productRating(product.id).opinionCount }})</small>
                    </div>
                  </div>
                  <div class="row g-3 align-items-center">
                    <div class="col-12 col-md-4 text-center">
                      <img class="product-image" [src]="productImage(product.image)" [alt]="product.name" />
                    </div>
                    <div class="col-12 col-md-8">
                      <table class="table table-sm product-features mb-3">
                        <tbody>
                          <tr>
                            <th scope="row">Procesador</th><td>{{ product.processor }}</td>
                            <td class="related-image-cell">@if (product.processorImage) { <img class="related-image" [src]="productImage(product.processorImage)" [alt]="product.processor" /> } @else { <i class="bi bi-cpu text-body-secondary"></i> }</td>
                          </tr>
                          <tr>
                            <th scope="row">Tarjeta gráfica</th><td>{{ product.graphicCard }}</td>
                            <td class="related-image-cell">@if (product.graphicCardImage) { <img class="related-image" [src]="productImage(product.graphicCardImage)" [alt]="product.graphicCard" /> } @else { <i class="bi bi-gpu-card text-body-secondary"></i> }</td>
                          </tr>
                          <tr>
                            <th scope="row">Sistema operativo</th><td>{{ product.operatingSystem }}</td>
                            <td class="related-image-cell">@if (product.operatingSystemImage) { <img class="related-image" [src]="productImage(product.operatingSystemImage)" [alt]="product.operatingSystem" /> } @else { <i class="bi bi-windows text-body-secondary"></i> }</td>
                          </tr>
                          <tr>
                            <th scope="row">Precio</th>
                            <td class="fw-semibold" [class.text-decoration-line-through]="hasDiscount(product)" [class.text-body-secondary]="hasDiscount(product)" [class.text-primary]="!hasDiscount(product)">{{ formatPrice(product.price) }}</td>
                            <td></td>
                          </tr>
                          @if (hasDiscount(product)) {
                            <tr>
                              <th scope="row">Descuento</th>
                              <td class="fw-semibold text-danger">{{ formatPrice(discountedPrice(product)) }}</td>
                              <td class="related-image-cell"><span class="badge text-bg-danger">-{{ product.discount }}%</span></td>
                            </tr>
                          }
                        </tbody>
                      </table>
                      <div class="d-flex gap-2">
                        <a class="btn btn-primary flex-grow-1" [routerLink]="['/portal/product', product.id]">Detalle</a>
                        <button class="btn btn-outline-primary" type="button" (click)="openComments(product)"><i class="bi bi-chat-left-text me-1"></i>Comentarios</button>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            } @empty {
              <p class="text-body-secondary mb-0">No hay productos registrados.</p>
            }
          }
        </div>
        @if (filteredProducts().length > pageSize) {
          <div class="card-footer d-flex align-items-center justify-content-end gap-2">
            <button class="btn btn-outline-secondary btn-sm" type="button" [disabled]="page() === 1" (click)="previousPage()">Anterior</button>
            <span class="small">Página {{ page() }} de {{ totalPages() }}</span>
            <button class="btn btn-outline-secondary btn-sm" type="button" [disabled]="page() === totalPages()" (click)="nextPage()">Siguiente</button>
          </div>
        }
      </section>
    </div>
  </div>
</div>

@if (commentsModalOpen()) {
  <div class="modal d-block comments-modal" animate.enter="app-modal-enter" animate.leave="app-modal-leave" tabindex="-1" role="dialog" aria-modal="true" aria-label="Comentarios del producto">
    <div class="modal-dialog modal-dialog-scrollable comments-modal-dialog" role="document">
      <div class="modal-content h-100">
        <div class="modal-header bg-primary text-white">
          <h2 class="modal-title fs-5 mb-0">{{ commentFormOpen() ? 'Escribir opinión' : 'Comentarios' }}</h2>
          <button class="btn-close btn-close-white" type="button" aria-label="Cerrar" (click)="closeComments()"></button>
        </div>
        <div class="modal-body">
          @if (commentFormOpen()) {
            <p class="fw-semibold mb-3">{{ commentsProductName() }}</p>
            <form id="comment-form" class="comment-form" [formGroup]="commentForm" (ngSubmit)="submitComment()">
              <div class="mb-3">
                <label class="form-label" for="fdRating">Calificación <span class="text-danger">*</span></label>
                <div id="fdRating" class="rating-input" role="radiogroup" aria-label="Calificación">
                  @for (rating of ratingStars; track rating) {
                    <button class="rating-star" type="button" [class.active]="rating <= commentForm.controls.fdRating.value" [attr.aria-label]="rating + ' estrellas'" (click)="setCommentRating(rating)">
                      <i class="bi" [class.bi-star-fill]="rating <= commentForm.controls.fdRating.value" [class.bi-star]="rating > commentForm.controls.fdRating.value"></i>
                    </button>
                  }
                  <span class="small text-body-secondary ms-2">{{ commentForm.controls.fdRating.value }} de 5</span>
                </div>
              </div>
              <div class="comment-content-group mb-0">
                <label class="form-label" for="fdContent">Opinión <span class="text-danger">*</span></label>
                <textarea id="fdContent" class="form-control" rows="7" maxlength="2000" formControlName="fdContent" placeholder="Escriba su opinión sobre el producto..."></textarea>
                @if (commentForm.controls.fdContent.touched && commentForm.controls.fdContent.invalid) { <div class="invalid-feedback d-block">La opinión es obligatoria.</div> }
              </div>
            </form>
          } @else {
            <p class="fw-semibold mb-3">{{ commentsProductName() }}</p>
            @if (commentsLoading()) {
              <p class="text-body-secondary mb-0">Cargando comentarios...</p>
            } @else {
              <div class="row g-2 rating-summary mb-3">
                <div class="col-12 col-sm-5">
                  <section class="card h-100 rating-score-card">
                    <div class="card-body text-center py-3">
                      <div class="display-5 fw-semibold">{{ formatAverageRating(deviceRating().averageRating) }}</div>
                      <div class="comment-rating my-1" [attr.aria-label]="deviceRating().averageRating + ' de 5 estrellas'">
                        @for (star of ratingStars; track star) { <i class="bi" [class.bi-star-fill]="star <= deviceRating().averageRating" [class.bi-star]="star > deviceRating().averageRating"></i> }
                      </div>
                      <small class="text-body-secondary">{{ deviceRating().opinionCount }} {{ deviceRating().opinionCount === 1 ? 'opinión' : 'opiniones' }}</small>
                    </div>
                  </section>
                </div>
                <div class="col-12 col-sm-7">
                  <section class="card h-100 rating-distribution-card">
                    <div class="card-body py-3">
                      @for (rating of ratingLevels; track rating) {
                        <div class="rating-distribution-row">
                          <span class="rating-distribution-label">{{ rating }} <i class="bi bi-star-fill"></i></span>
                          <div class="progress" role="progressbar" [attr.aria-label]="rating + ' estrellas'" [attr.aria-valuenow]="ratingPercentage(rating)" aria-valuemin="0" aria-valuemax="100">
                            <div class="progress-bar bg-warning" [style.width.%]="ratingPercentage(rating)"></div>
                          </div>
                          <span class="rating-distribution-count">{{ ratingCount(rating) }}</span>
                        </div>
                      }
                    </div>
                  </section>
                </div>
              </div>
              <div class="comments-list">
              @for (comment of productComments(); track comment.idRegister) {
                <article class="comment-item">
                  <div class="row g-2 mb-2">
                    <div class="col-12">
                      <h3 class="h6 mb-0"><i class="bi bi-person-circle me-1"></i>{{ comment.userName }}</h3>
                    </div>
                    <div class="col-6">
                      <span class="comment-rating" [attr.aria-label]="comment.fdRating + ' de 5 estrellas'">
                        @for (star of ratingStars; track star) { <i class="bi" [class.bi-star-fill]="star <= comment.fdRating" [class.bi-star]="star > comment.fdRating"></i> }
                      </span>
                    </div>
                    <div class="col-6 text-end">
                      <small class="text-body-secondary">{{ formatCommentDate(comment) }}</small>
                    </div>
                  </div>
                  <p class="mb-0 comment-content">{{ comment.fdContent }}</p>
                </article>
              } @empty {
                <p class="text-body-secondary mb-0">Este producto aún no tiene comentarios.</p>
              }
              </div>
            }
          }
        </div>
        <div class="modal-footer">
          @if (commentFormOpen()) {
            <button class="btn btn-outline-secondary" type="button" [disabled]="commentSubmitting()" (click)="cancelCommentForm()">Volver</button>
            <button class="btn btn-primary" type="submit" form="comment-form" [disabled]="commentSubmitting()">
              @if (commentSubmitting()) { <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>Publicando... } @else { Publicar opinión }
            </button>
          } @else {
            <button class="btn btn-outline-secondary" type="button" (click)="closeComments()">Cerrar</button>
            <div>
              <button class="btn btn-primary" type="button" [disabled]="!authSession.isAuthenticated() || commentAuthorLoading()" (click)="openCommentForm()">
                @if (commentAuthorLoading()) { <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>Preparando... } @else { Escribir opinión }
              </button>
              @if (!authSession.isAuthenticated()) { <small class="d-block text-body-secondary mt-1">Inicie sesión para escribir una opinión.</small> }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" animate.enter="app-backdrop-enter" animate.leave="app-backdrop-leave"></div>
}
